<template>
    <div class="row-fill container-row">
      <vue-headful :title="'مُرَيجَع | ' + lemposToLemma(collLempos)"/>
      <collocation-overview :lempos="lempos" class="col-fill d-none d-lg-flex"/>
      <collocation-details :lempos="collLempos" :pattern="collPattern" :linkToLemmaView="$mq.phone" class="col-fit side-pane"/>
    </div>
</template>

<script>
import CollocationDetails from '../components/CollocationDetails.vue'
import CollocationOverview from '../components/CollocationOverview.vue'
import { api } from '../mixins/api.js'
import vueHeadful from 'vue-headful'

export default {
  name: 'CollocationView',
  mixins: [ api ],
  props: {
    lempos: String,
    collLempos: String,
    collPattern: String
  },
  components: {
    CollocationOverview,
    CollocationDetails,
    vueHeadful
  }
}
</script>

<style scoped>
@media (max-width: 991px) {
  .side-pane {
    width: 100%
  }
}

</style>
